/**
 * Recently viewed products.
 *
 * Loaded globally from layout/theme.liquid so it can do two jobs:
 *   1. On any product page, push that product's handle onto a per-browser list
 *      in localStorage (most-recent first, de-duped, capped).
 *   2. For each `.spi_recently-viewed` section on the page, fetch a product card
 *      per stored handle (/products/{handle}?section_id=recently-viewed-card),
 *      drop the cards into the grid, and fire `spi:products:appended` so
 *      section-collection.js wires up swatches / add-to-cart / quick view.
 *
 * The list never leaves the browser — no cookies, no network beyond the card
 * fetches.
 */
(function () {
  if (window.__spiRecentlyViewed) return;
  window.__spiRecentlyViewed = true;

  var KEY = 'evora:recently-viewed';
  var MAX_STORED = 20;

  function readList() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function writeList(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX_STORED)));
    } catch (e) {
      /* private mode / quota — non-fatal */
    }
  }

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* 1. Record the product being viewed right now. */
  var here = currentHandle();
  if (here) {
    var list = readList().filter(function (h) {
      return h !== here;
    });
    list.unshift(here);
    writeList(list);
  }

  /* 2. Populate recently-viewed sections. */
  function initSection(root) {
    var track = root.querySelector('[data-recently-viewed-track]');
    if (!track || track.dataset.rvReady === 'true') return;
    track.dataset.rvReady = 'true';

    var limit = parseInt(root.dataset.limit, 10) || 4;
    var cardSection = root.dataset.cardSection || 'recently-viewed-card';
    var excludeCurrent = root.dataset.excludeCurrent !== 'false';
    var showQuickView = root.dataset.showQuickView !== 'false';
    var showAddToCart = root.dataset.showAddToCart !== 'false';
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var handles = readList();
    var cur = currentHandle();
    if (excludeCurrent && cur) {
      handles = handles.filter(function (h) {
        return h !== cur;
      });
    }
    handles = handles.slice(0, limit);

    if (!handles.length) {
      if (!designMode) root.hidden = true;
      return;
    }

    Promise.all(
      handles.map(function (h) {
        return fetch(window.routes.root_url.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=' + cardSection)
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (chunks) {
      var frag = document.createDocumentFragment();
      var added = 0;

      chunks.forEach(function (html) {
        if (!html) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var card = wrap.querySelector('.spi_product-card');
        if (!card) return;

        if (!showQuickView) {
          var qv = card.querySelector('.spi_quick-view');
          if (qv) qv.remove();
        }
        if (!showAddToCart) {
          card
            .querySelectorAll('.spi_product-cart-wrapper, .spi_product-cart-icon')
            .forEach(function (el) {
              el.remove();
            });
        }

        frag.appendChild(card);
        added++;
      });

      if (!added) {
        if (!designMode) root.hidden = true;
        return;
      }

      /* Clear the theme-editor skeletons, then drop the real cards in. */
      track.innerHTML = '';
      track.appendChild(frag);
      root.hidden = false;

      document.dispatchEvent(new CustomEvent('spi:products:appended'));

      /* The track is a slider (assets/section-featured-collection.js): its
         arrow/progress state is only recalculated on scroll/resize, and it
         already initialized against an empty track before these cards
         landed — nudge it to recompute against the real width now. */
      window.dispatchEvent(new Event('resize'));
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('.spi_recently-viewed[data-recently-viewed]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
